import { TruckIcon } from "@heroicons/react/24/outline";
import { Text } from "./base/Text";
import { handleApiError } from "utils/errorHandlers";
import { useEffect, useState } from "react";
import { useUser } from "context/user-context";
import { ApiLoading } from "./ApiLoading";
import clsx from "clsx";
import {Livraison, getLivraisonEnCours} from "../services/apiLivraisons";

export const LivraisonBanniere = ({ className }: { className?: string }) => {
  const { user } = useUser();
  const [livraison, setLivraison] = useState<Livraison | null>(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<Record<string, string[]>>({});

  useEffect(() => {
    if (user?.group_id) {
      setLoading(true);
      const fetchLivraison = async () => {
        try {
          const data = await getLivraisonEnCours(user.group_id!);
          setLivraison(data);
        } catch (error: any) {
          setErrors(handleApiError(error));
        } finally {
          setLoading(false);
        }
      };

      fetchLivraison();
    }
  }, []);

  // affiche rien pour les admin
  if (!user?.group_id) {
    return null;
  }

  if (errors && errors.general) {
    return <ApiLoading type="error">{errors.general[0]}</ApiLoading>;
  }
  if (loading) {
    return <ApiLoading type="loading">Chargement des livraisons...</ApiLoading>;
  }

  const classeColor = livraison?.date_livraison ? "border-primary-600 border bg-primary-100" : "border-alert-600 border bg-alert-100";

	return (
		<div className={clsx('flex gap-4 p-4 rounded-md justify-start items-center', classeColor, className)}>
        <TruckIcon className={`w-10 h-10 ${livraison?.date_livraison ? "text-primary-500" : "text-alert-500"}`} />
        <div className='flex flex-col flex-1'>
          <Text size='small' className='text-gray-600'>Prochaine livraison</Text>
          {livraison?.date_livraison && livraison?.adresse ? (
            <Text>Le {livraison?.date_livraison_display} au {livraison?.adresse}</Text>
          ) : (
            <Text>Il n'y a pas encore de livraison planifiée, vos achats seront automatiquement rattachés à la prochaine livraison. (délais maximum: 1 mois)</Text>
          )}
        </div>
      </div>
	);
};
